export default "__VITE_ASSET__ea689c67__"